import { useCallback, useContext } from "react";
import { notify } from "../../../../utils/notify";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  findContasReceber,
  findCrByContracts,
} from "../../../../repositories/qerpapi/erp/financeiro/ContasReceberRepository";
import { FaturamentoContratoContext } from "../contexts/FaturamentoContratoContext";
import MaskService from "../../../../utils/mask/maskService";
import {
  formatDate,
  formatDateGetCurrentMonth,
} from "../../../../utils/formatDate";
import getDayOfCurrentMonth from "../../../../utils/getDayOfCurrentMonth";
import { sendProccessInvoice } from "../../../../repositories/qerpapi/erp/financeiro/ContratosRepository";
import { findAgencia } from "../../../../repositories/qerpapi/erp/financeiro/AgenciasRepository";
import moment from "moment";
import Swal from "sweetalert2";

export default function useGerenciamentoContratoController() {
  const {
    client,
    initialDate,
    finalDate,
    filterBy,
    typeContract,
    billingStatus,
    inDays,
    filterDefaulters,
    setMainLoading,
    setItensTable,
    selectedItem,
    setContracts,
    setReimbursableExpenses,
    setTotalLooseItem,
    setTotalBilling,
    taxCnab,
    setTaxCnab,
    taxPix,
    setTaxPix,
    setTotalQyonBank,
    setTotalTaxCnab,
    setTotalTaxPix,
    setNetTotal,
    setSelectedItem,
    setPagePropDefault,
    setNegativeQB,
    setDisabledButtonSearch,
    setLoadingBtnSearch,
    expiredTotal,
    setExpiredTotal,
    expiringTotal,
    setExpiringTotal,
  } = useContext(FaturamentoContratoContext);

  const { queryParams } = useContext(QueryParamsContext);

  const initHandleSearchTitles = useCallback(async () => {
    try {
      setMainLoading(true);
      setDisabledButtonSearch(true);
      setLoadingBtnSearch(true);

      const paramValues = {
        initialDate: formatDate({
          date: getDayOfCurrentMonth("first"),
          separator: "-",
          format: "yyyy-mm-dd",
        }),
        finalDate: formatDate({
          date: getDayOfCurrentMonth("last"),
          separator: "-",
          format: "yyyy-mm-dd",
        }),
        filterBy: "dueDate",
        typeContract: "all",
        billingStatus: "all",
        inDays: "30",
        filterDefaulters: true,
      };

      const callback = await findCrByContracts({
        empresaCnpj: queryParams.empresa_cnpj,
        companyId: queryParams.empresa_id,
        paramValues,
      });

      if (!callback.success) {
        return notify("Erro ao buscar titulos");
      }

      let countExpiringTotal = 0;
      let countExpiredTotal = 0;

      const withBackground = callback.data.map((row) => {
        if (!["faturado", "processando"].includes(row?.status_geral)) {
          setSelectedItem((old) => [...old, row]);
        }

        let rowDate = row?.contrato?.vigencia_renovacao || null;

        if (rowDate) {
          const searchDate = moment(new Date(), "YYYY-MM-DD").format(
            "YYYY-MM-DD"
          );
          const searchDateSplit = searchDate.split("-");
          const dateToCompare = new Date(
            searchDateSplit[0],
            searchDateSplit[1] - 1,
            1
          );

          const splitRowDate = rowDate.split("/");
          const rowMonth = splitRowDate[0];
          const rowYear = splitRowDate[1];
          const formatedRowDate = new Date(rowYear, rowMonth - 1, 1);

          if (formatedRowDate.getTime() === dateToCompare.getTime())
            countExpiringTotal++;
          if (formatedRowDate.getTime() < dateToCompare.getTime())
            countExpiredTotal++;
        }

        return {
          ...row,
          alternativeCheck:
            row?.mes_competencia === row?.contrato?.vigencia_renovacao,
        };
      });

      setExpiredTotal(MaskService.toMask("integer", countExpiredTotal));
      setExpiringTotal(MaskService.toMask("integer", countExpiringTotal));

      setItensTable(withBackground);
    } catch (error) {
      setExpiredTotal("0");
      setExpiringTotal("0");
      console.error(error);
    } finally {
      setMainLoading(false);
      setDisabledButtonSearch(false);
      setLoadingBtnSearch(false);
    }
  }, [
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    setItensTable,
    setMainLoading,
    setSelectedItem,
    setDisabledButtonSearch,
    setLoadingBtnSearch,
    setExpiredTotal,
    setExpiringTotal,
  ]);

  const handleSearchTitles = async (statusFastSearch = null) => {
    try {
      setPagePropDefault(0);
      setSelectedItem([]);
      setMainLoading(true);
      setDisabledButtonSearch(true);
      setLoadingBtnSearch(true);

      if (filterBy.value === "current") {
        var currentInitDate = formatDateGetCurrentMonth({
            date: initialDate,
            separator: "/",
            format: "mm/yyyy",
          }),
          currentFinalDate = formatDateGetCurrentMonth({
            date: finalDate,
            separator: "/",
            format: "mm/yyyy",
          });
      }

      const paramValues = {
        clientId: client?.id || null,
        initialDate:
          currentInitDate ??
          moment(initialDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        finalDate:
          currentFinalDate ??
          moment(finalDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        filterBy: filterBy.value,
        typeContract: typeContract.value,
        billingStatus: statusFastSearch ?? billingStatus.value,
        inDays,
        filterDefaulters,
      };

      const callback = await findCrByContracts({
        empresaCnpj: queryParams.empresa_cnpj,
        companyId: queryParams.empresa_id,
        paramValues,
      });

      if (!callback.success) {
        return notify("Erro ao buscar titulos");
      }

      let countExpiringTotal = 0;
      let countExpiredTotal = 0;

      const withBackground = callback.data.map((row) => {
        if (!["faturado", "processando"].includes(row?.status_geral)) {
          setSelectedItem((old) => [...old, row]);
        }

        let rowDate = row?.contrato?.vigencia_renovacao || null;

        if (initialDate && rowDate) {
          const searchDate = initialDate;
          const searchDateSplit = searchDate.split("-");
          const dateToCompare = new Date(
            searchDateSplit[0],
            searchDateSplit[1] - 1,
            1
          );

          const splitRowDate = rowDate.split("/");
          const rowMonth = splitRowDate[0];
          const rowYear = splitRowDate[1];
          const formatedRowDate = new Date(rowYear, rowMonth - 1, 1);

          if (formatedRowDate.getTime() === dateToCompare.getTime())
            countExpiringTotal++;
          if (formatedRowDate.getTime() < dateToCompare.getTime())
            countExpiredTotal++;
        }

        return {
          ...row,
          alternativeCheck:
            row?.mes_competencia === row?.contrato?.vigencia_renovacao,
        };
      });

      setExpiredTotal(MaskService.toMask("integer", countExpiredTotal));
      setExpiringTotal(MaskService.toMask("integer", countExpiringTotal));

      setItensTable(withBackground);
    } catch (error) {
      setExpiredTotal("0");
      setExpiringTotal("0");
      console.error(error);
    } finally {
      setMainLoading(false);
      setDisabledButtonSearch(false);
      setLoadingBtnSearch(false);
    }
  };

  const handleTaxBankSlip = useCallback(async () => {
    try {
      setMainLoading(true);
      const agencies = await findAgencia(
        queryParams.empresa_cnpj,
        queryParams.usuario_id,
        "banco"
      );

      if (agencies.success) {
        const index = agencies.data.findIndex((agency) => {
            return agency?.banco?.codigo === "000";
          }),
          qyonBank = agencies.data[index];

        if (qyonBank) {
          const taxPix = qyonBank?.taxa_pix
              ? MaskService.toMask(
                  "decimal",
                  parseFloat(qyonBank?.taxa_pix).toFixed(2),
                  2
                )
              : "0",
            taxCnab = qyonBank?.boleto_taxa
              ? MaskService.toMask(
                  "decimal",
                  parseFloat(qyonBank?.boleto_taxa).toFixed(2),
                  2
                )
              : "0";
          setTaxCnab(taxCnab);
          setTaxPix(taxPix);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  }, [
    setMainLoading,
    queryParams.empresa_cnpj,
    queryParams.usuario_id,
    setTaxCnab,
    setTaxPix,
  ]);

  const simulatedBillingQyonBank = useCallback(() => {
    let valueTotalQB = 0,
      valueTotalTaxCnab = 0,
      valueTotalTaxPix = 0,
      valueTotalNet = 0;

    selectedItem.forEach((rowQB) => {
      if (rowQB?.agencia?.banco?.codigo === "000") {
        let valueRowQB = parseFloat(rowQB.valordocto);

        if (
          rowQB?.tipo_boleto === "cnab" &&
          rowQB?.agencia?.cnab_tarifa_debitada_valor_recebido === "N"
        )
          valueTotalTaxCnab += MaskService.removeMaskDecimal(taxCnab);
        else if (
          rowQB?.tipo_boleto === "pix" &&
          rowQB?.agencia?.cnab_tarifa_debitada_valor_recebido === "N"
        )
          valueTotalTaxPix += MaskService.removeMaskDecimal(taxPix);

        valueTotalQB += valueRowQB;
      }
    });

    valueTotalNet += valueTotalQB - (valueTotalTaxCnab + valueTotalTaxPix);

    setTotalQyonBank(
      MaskService.toMask("decimal", parseFloat(valueTotalQB).toFixed(2), 2)
    );
    setTotalTaxCnab(
      MaskService.toMask("decimal", parseFloat(valueTotalTaxCnab).toFixed(2), 2)
    );
    setTotalTaxPix(
      MaskService.toMask("decimal", parseFloat(valueTotalTaxPix).toFixed(2), 2)
    );
    setNetTotal(
      MaskService.toMask("decimal", parseFloat(valueTotalNet).toFixed(2), 2)
    );

    if (Math.sign(valueTotalNet) === -1) setNegativeQB(true);
    else setNegativeQB(false);
  }, [
    selectedItem,
    taxCnab,
    taxPix,
    setTotalQyonBank,
    setTotalTaxCnab,
    setTotalTaxPix,
    setNetTotal,
    setNegativeQB,
  ]);

  const calculateInvoice = useCallback(async () => {
    let valueContracts = 0,
      valueReimbursableExpenses = 0,
      valueTotalBilling = 0,
      looseTotalValue = 0;

    selectedItem?.forEach((row) => {
      valueContracts += parseFloat(row.valordoctooriginal || 0);
      valueTotalBilling += parseFloat(row.valordocto || 0);
      looseTotalValue += parseFloat(row.valor_servico_avulso || 0);
      valueReimbursableExpenses += parseFloat(
        row.valor_despesa_reembolsavel || 0
      );
    });

    setContracts(
      MaskService.toMask("decimal", parseFloat(valueContracts).toFixed(2), 2)
    );

    setTotalBilling(
      MaskService.toMask("decimal", parseFloat(valueTotalBilling).toFixed(2), 2)
    );

    setTotalLooseItem(
      MaskService.toMask("decimal", parseFloat(looseTotalValue).toFixed(2), 2)
    );

    setReimbursableExpenses(
      MaskService.toMask(
        "decimal",
        parseFloat(valueReimbursableExpenses).toFixed(2),
        2
      )
    );
  }, [
    selectedItem,
    setContracts,
    setReimbursableExpenses,
    setTotalBilling,
    setTotalLooseItem,
  ]);

  const sendInvoice = async () => {
    let dontContinue = false;

    if (parseInt(expiringTotal) > 0 || parseInt(expiredTotal) > 0) {
      await Swal.fire({
        icon: "question",
        text: "Existem contratos à vencer ou vencidos, deseja continuar com o Faturamento?",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        showConfirmButton: true,
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusCancel: true,
      }).then(async (result) => {
        if (!result.isConfirmed) {
          dontContinue = true;
        }
      });
    }

    if (dontContinue) return;

    try {
      let data = [],
        error = false;

      if (selectedItem.length === 0)
        return notify(
          "Favor, selecione algum título para faturamento!",
          true,
          "warning"
        );

      let dontConfirm = false;

      await Swal.fire({
        width: 800,
        html: `
           <span className="Title" style="font-size: 1.5em;font-weight: 600;">
            Agora vamos iniciar o seu processo de faturamento One Click!
          </span>
          <ul style="text-align:left;">
            <li>Gerar boletos</li>
            <li>Emitir NFSe</li>
            <li>Gerar Demonstrativos Financeiros</li>
            <li> Enviar e-mails aos clientes sobre o esse faturamento.</li>
          </ul>
          <div style="text-align:left; font-size: 16px;">
          <ul style="padding-left: 0;">
              <li>E a contabilização é feita no <b>Qyon Solução Contábil</b> após a baixa.</li>
          </ul>
              <p>Não precisa aguardar a finalização do processo. Continue com suas atividades e o Qyon Bot avisa quando tudo estiver concluído.</p>
    
              </p>Simplifique seu faturamento com rapidez e eficiência. Tudo isso em apenas 1 clique! 🚀</p>
          </div>
    
           <span className="Title" style="font-size: 1.2em;font-weight: 600;">
            Deseja Continuar?
          </span>
          `,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (!result.isConfirmed) {
          dontConfirm = true;
        }
      });

      if (dontConfirm) return;

      setMainLoading(true);

      for (let value of selectedItem) {
        data.push({
          billsToReceiveId: value.id,
          idUsuario: queryParams.usuario_id,
          proccess: {
            nfse: !["concluido", "processando"].includes(
              value.status_nfse
            ),
            boleto: !["concluido", "processando"].includes(value.status_boleto),
            demonstrativoFinanceiro: !["concluido", "processando"].includes(
              value.status_demonstrativo_financeiro
            ),
            email: !["concluido", "processando"].includes(value.status_email),
          },
        });
      }

      if (!error) {
        const body = {
          empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
          data: data,
        };

        const callback = await sendProccessInvoice({ body });

        if (callback.success)
          return notify("Sucesso ao enviar para faturamento", true, "success");
        else return notify("Erro ao enviar para faturamento");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
      handleSearchTitles();
    }
  };

  const findLogsInvoiceByIdCr = async (idCr) => {
    try {
      setMainLoading(true);

      const callback = await findContasReceber({
        empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
        include: "queuelog",
        id: idCr,
      });

      if (!callback.success)
        return notify("Erro ao buscar registros de alterações.");
      else if (
        callback.success &&
        callback?.data?.queuelog &&
        !callback?.data?.queuelog.length
      )
        return notify("Título sem registros de alterações", true, "warning");

      return callback;
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  return {
    handleSearchTitles,
    sendInvoice,
    initHandleSearchTitles,
    getDayOfCurrentMonth,
    calculateInvoice,
    simulatedBillingQyonBank,
    handleTaxBankSlip,
    findLogsInvoiceByIdCr,
  };
}
